module.exports = __webpack_public_path__ + "static/media/partial-ipad.4b8b5d82.png";